import HomeOutline from '@monofront/design-system/visuals/Icons/Old/HomeOutline';
import { useAuthentication } from '@context/businessContainer';
import { ICollectionTag } from '@monofront/types';
import React from 'react';
import { useTranslations } from 'next-intl';
import Breadcrumb from '@components/Breadcrumb';

interface ICollectionBreadcrumbProps {
  breadcrumb?: ICollectionTag[];
  currentPathTitle: string;
}

export const CollectionBreadcrumb: React.FC<ICollectionBreadcrumbProps> = ({
  breadcrumb = [],
  currentPathTitle,
}) => {
  const { isAuthenticated } = useAuthentication();
  const [, ...breadcrumbsWithoutFirst] = breadcrumb || [];
  const tGlobal = useTranslations('Global');

  return (
    <Breadcrumb>
      <Breadcrumb.Link href={isAuthenticated ? '/home' : '/'}>
        <HomeOutline
          color="var(--clr-tertiary-1)"
          width={24}
          height={24}
          role="img"
          aria-label={tGlobal('goHome')}
        />
      </Breadcrumb.Link>
      {breadcrumbsWithoutFirst?.map((link) => (
        <Breadcrumb.Link key={link.omsId} href={`/collections/${link.handle}`}>
          {link.title}
        </Breadcrumb.Link>
      ))}
      <Breadcrumb.Link>{currentPathTitle}</Breadcrumb.Link>
    </Breadcrumb>
  );
};
